<template>
    <div id="main">
        <div class="alert-wrapper">
            <alert-container :messages="msgs" />
        </div>
        <div class="page acertos">
            <div class="vertical-flow">
                <div class="listing-header">
                    <!-- TÍTULO E BREADCRUMB -->
                    <div class="title-breadcrumb">
                        <h1 class="title">{{ $t("acertos") }}</h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li><a>{{ $t("despesas") }}</a></li>
                                <li><a aria-current="page">{{ $t("acertos") }}</a></li>
                            </ul>
                        </nav>
                    </div>
                </div>
                <!-- FILTROS -->
                <div class="search-and-filter">
                    <div class="columns is-variables is-desktop">
                        <div class="column is-4 header-search">
                            <search-bar
                                :onSearch="debouncedOnSearch"
                                tooltipLabel="msg-campo-busca-acertos"
                            />
                        </div>
                        <!-- Data Inicio-->
                        <div class="column is-3">
                            <verified-date-picker
                                ref="startDate"
                                :dateType="'startDate'"
                                :tooltip="true"
                                :tooltipValue="'msg-nao-aplica-filtro-data'"
                                :tooltipPosition="'is-bottom'"
                                :value="datainicial"
                                :endDate="datafinal"
                                :title="'data-inicio'"
                                @carregarDados="carregarDados()"
                                @input="changeStartDate"
                                :disabled="situacao.paramQuery=='ABERTO'"
                                :required="(situacao.paramQuery=='ABERTO')?false:true"
                                :invalid="(situacao.paramQuery=='ABERTO')?false:startDateInvalid"
                            />
                        </div>
                        <!-- Data Fim-->
                        <div class="column is-3">
                            <verified-date-picker
                                ref="endDate"
                                :dateType="'endDate'"
                                :tooltip="true"
                                :tooltipValue="'msg-nao-aplica-filtro-data'"
                                :tooltipPosition="'is-bottom'"
                                :value="datafinal"
                                :startDate="datainicial"
                                :title="'data-fim'"
                                @carregarDados="carregarDados()"
                                @input="changeEndDate"
                                :disabled="situacao.paramQuery=='ABERTO'"
                                :required="(situacao.paramQuery=='ABERTO')?false:true"
                                :invalid="(situacao.paramQuery=='ABERTO')?false:endDateInvalid"
                            />
                        </div>
                        <!-- SITUACAO -->
                        <div class="situacao-select column is-2">
                            <label v-text="$t('situacao')" />
                            <v-select
                                ref="situacaoInput"
                                class="is-100"
                                label="label"
                                :options="situacoes"
                                @input="updateSituacao"
                                v-model="situacaoLabel"
                            >
                                <template slot="option" slot-scope="option">
                                    {{ $t(option.label) }}
                                </template>
                                <template slot="selected-option" slot-scope="option">
                                    {{ $t(option.label) }}
                                </template>
                                <template slot="no-options">{{$t('sem-resultados')}}</template>
                            </v-select>
                        </div>
                    </div>
                </div>
                <!--Tabela-->
                <section class="lps-table registry-wrapper">
                    <container-loader v-if="isLoading && !$store.getters.isLoading" />
                    <empty-table-message class="mt-3" v-if="isEmpty" />
                    <b-table
                        :data="acertos"
                        class="data-table"
                        hoverable
                        responsive
                        @sort="sortTable"
                        backend-sorting
                        backend-pagination
                    >
                        <!--COLOCAR OS LABELS PARA OS DICIONARIOS -->
                            <b-table-column
                                v-for="(f, i) in fields"
                                :key="i"
                                :field="f.key"
                                :label="f.key == 'deletar' ? '' : $t(f.key)"
                                :width="f.width"
                                :class="f.key"
                                :sortable="f.sortable"
                                :custom-sort="f.sortFn"
                                v-slot="props"
                            >
                                <div class="has-text-left" v-if="f.key == 'id'">
                                    <p>{{ props.row.id==0?"—":props.row.id }}</p>
                                </div>
                                <div class="has-text-left" v-else-if="f.key == 'nome'">
                                    <a 
                                        :click="promptConfirm('usuario-possui-despesa-automaticas-para-serem-geradas', props.row)" 
                                        v-if="props.row.valortotal == 0"
                                    >
                                        {{ props.row.usuario.nome }}
                                    </a>
                                    <div v-else>
                                        <div v-if="props.row.gerandoDespesa == 1">
                                            <a @click="promptOk('geracao-executando')">
                                                {{ props.row.usuario.nome }}
                                            </a>
                                            
                                        </div>
                                        <div v-else>
                                            <router-link
                                            :to="{
                                            name: 'des-lista-acertos',
                                            params: {
                                                userId: props.row.usuario.id,
                                                situacaoId: situacao.id
                                            },
                                            query: {
                                                userName: props.row.usuario.nome,
                                                valorTotalAcerto: props.row.valortotal,
                                                acertoId: props.row.id,
                                            }
                                        }"
                                            >
                                                {{ props.row.usuario.nome }}
                                            </router-link>
                                        </div>
                                        
                                    </div>
                                </div>

                                <div class="tooltip" v-else-if="f.key == 'valor'">
                                    
                                    {{
                                        getDecimal(props.row.valortotal, null, true)
                                    }}
                                    <div v-if="props.row.valortotal == 0">
                                        <b-icon 
                                            icon="information" 
                                            size="is-small" 
                                            v-tippy 
                                            :title="$t('msg-despesas-pendentes-geracao')"
                                        />
                                    </div>
                                </div>

                                <div v-else-if="f.key == 'spinner_em_exec'">
                                    <span v-if="props.row.gerandoDespesa == 1">
                                        <i class="fa fa-circle-notch fa-2x fa-spin color" />
                                    </span>
                                </div>

                                <div v-else-if="f.key == 'data'">
                                    <span v-if="props.row.datahorainc">
                                        {{ props.row.datahorainc | moment("L") }}
                                    </span>
                                </div>

                                <div v-else-if="f.key == 'empresa'">
                                    <span v-if="props.row.empresa">
                                        {{ props.row.empresa.nome }}
                                    </span>
                                </div>

                                <div v-else-if="f.key == 'situacao'">
                                    <b-tag
                                        class="table-tag table-tag-full-width"
                                        :type="isStatusButtonType(props.row.tipo)"
                                        size="is-medium"
                                        >{{ $t(props.row.tipo.toLowerCase()) }}</b-tag
                                    >
                                </div>

                                <div>
                                    <span v-if="f.key == 'deletar'">
                                        <b-button
                                            v-if="props.row.tipo == 'FECHADO' && permissao.delete"
                                            type="is-danger"
                                            @click="promptForDelete(props.row)"
                                            icon-right="delete"
                                            v-tippy 
                                            :title="$t('desativar')"
                                        />
                                    </span>
                                </div>
                            </b-table-column>
                        <template slot="footer">
                            <th v-for="f in fieldsCopy" :key="f.key + '-' + f.nome" :id="f.key">
                                <span v-if="f.key == 'nome'"
                                    >{{ acertos.length }} {{ $t("registro") }}</span
                                >
                                <span v-if="f.key == 'valor'"
                                    >{{ getDecimal(valorTotalAcertos, null, true) }}</span
                                >
                                <span v-else></span>
                            </th>
                        </template>
                    </b-table>
                </section>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>
        </div>
        <!-- end .page.mb-0 -->
    </div>
    <!-- end #main -->
</template>

<script>
import AcertoService from "@/services/despesas/AcertosService";
import Message from "@/models/Message";
import ContainerLoader from "@/components/content/loader/ContainerLoader";
import DespesaAutomaticaService from "@/services/despesas/DespesaAutomaticaService";

export default {
    components: {
        ContainerLoader,
    },
    data() {
        return {
            filtros: {
                situacao: {},
                datainicial: this.$moment().subtract(30, "days").format("YYYY-MM-DD"),
            },
            situacao: { paramQuery: "ABERTO", id: 2 },
            situacaoLabel: { label: "abertos", id: 2 },
            situacoes: [
                { paramQuery: "EXCLUIDO", label: "excluidos", id: 0 },
                { paramQuery: "FECHADO", label: "fechados", id: 1 },
                { paramQuery: "ABERTO", label: "abertos", id: 2 },
                { paramQuery: "TODOS", label: "todos", id: 3 },
            ],
            fields: [
                { key: "id", width: 5, sortable: false, sortFn: null },
                { key: "nome", width: 30, sortable: true, sortFn: null },
                { key: "empresa", width: 20, sortable: true, sortFn: null},
                { key: "valor", width: 20, sortable: true, sortFn: null },
                { key: "data", width: 10, sortable: true, sortFn: null },
                { key: "situacao", width: 9, sortable: false, sortFn: null },
                { key: "deletar", width: 3, sortable: false, sortFn: null },
            ],
            pagination: {
                resetPagination: false,
                perPageOptions: [10,25,50,100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1
            },
            isFocusable: true,
            msgs: [],
            showTable: false,
            fieldsCopy: [],
            acertos: [],
            spinner: true,
            service: new AcertoService(this.$http, this.$router),
            serviceDespesaAutomatica: new DespesaAutomaticaService(this.$http, this.$router),
            debouncedOnSearch: Function,
            query: "",
            sort: "data",
            order: "desc",
            isLoading: true,
            isEmpty: false,
            valorTotalAcertos: 0,
            datainicial: null,
            datafinal: null,
            startDateInvalid: false,
            endDateInvalid: false,
            delete: null,
            permissao: {},
            usuarioGerarDespesa : {},
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.permissao = this.hasPermissionAccess("despesas", "acertos", "des-acertos");
        if (!this.permissao.read){
            this.$store.dispatch('accessDenied', { value: true, title: 'des-acertos' });
        } else {
            // console.log(this.$route.params);
            // console.log(this.$route.params.id == 1 && this.$route.params.label == "fechados");
            if(this.$route.params.id == 1 && this.$route.params.label == "fechados"){
                this.situacao = this.situacoes[1];
                this.situacaoLabel = this.situacoes[1];
                if(this.datainicial==null) this.datainicial = this.$moment().subtract(1, 'M').toDate()
                if(this.datafinal==null) this.datafinal = this.$moment().toDate()
                this.carregarDados();
                this.updatePageInterval();
            } else {
                this.carregarDados();
                this.updatePageInterval();
            }
            
            
        }
    },
    methods: {
        updatePageInterval(){
            setInterval(() => { this.verificaGeracaoEmExec() }, 30000);
        },
        verificaGeracaoEmExec(){
            let emExec = false;
            for(let a of this.acertos){
                if(a.gerandoDespesa == 1){
                    emExec = true;
                }
            }
            if(emExec){
                this.carregarDados();
            }
        },
        updatePagination(value){
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        // Recebe o $emit do VerifiedDatePicker, adiciona o valor na variavel local que retorna para a prop do VerifiedDatePiker
        changeStartDate(date){
            this.datainicial = date
            this.startDateInvalid = (this.datainicial==null)? true:false
        },
        changeEndDate(date){
            this.datafinal = date
            this.endDateInvalid = (this.datafinal==null)? true:false
        },
        geraDespesaAutomatica(){
            this.serviceDespesaAutomatica.geraDespesaAutomatica(this.usuarioGerarDespesa.idusuario)
                .then(body => {
                    if (body.message === 'msg-gerado-criticas') {
                        this.promptMessageCritica('msg-gerado-criticas');
                    }
                })
                .catch((e) => {
                    console.log(e);
                    this.isLoading = false;
                    console.error("Erro ao gerar despesas: ", {e});
                })
                .finally(()=> {
                    console.log("Criação das despesas automaticas finalizadas.");
                    this.isGeneratingExpenses = false;
                    this.isLoading = false;
                    this.carregarDados();
                })

                for(let a of this.acertos){
                    if(a.usuario.idusuario == this.usuarioGerarDespesa.idusuario){
                        a.emExec = true;
                        a.gerandoDespesa = 1;
                    }
                }

                setTimeout(() => {
                    this.$root.showMessage('success', 'geracao-em-exec');
                    this.updatePageInterval();
                }, 500);
                    
        },
        removeFieldEmpresa(remover){
            if(remover){
                return this.fields.filter(f => f.key != "empresa");
            } else {
                return this.fields;
            }
        },
        carregarDados(currentPage=1) {
            this.showTable = false;
            // Caso a situacao seja diferente de fechado ele remove o campo EMPRESAS da btable
            if(this.situacao.id != 1){
            // this.fields.splice(this.fields.findIndex(e => e.key === "empresa"),1);
                this.fieldsCopy = this.removeFieldEmpresa(true);
                
            } else {
                this.fieldsCopy = this.removeFieldEmpresa(false);
            }
            if(currentPage==1&&this.pagination.currentPage!=1)this.pagination.resetPagination=true;
            this.isLoading = true;
            let valid = true
            if(this.situacao.paramQuery!='ABERTO' && (this.datainicial==null||this.datafinal==null)){
                valid = false
            }
            let filtro = {
                datainicial: 
                    (this.datainicial)? this.$moment(this.datainicial).format("YYYY-MM-DD") : null,
                datafinal: 
                    (this.datafinal)? this.$moment(this.datafinal).format("YYYY-MM-DD") : null,
                situacao: this.situacao ? this.situacao.paramQuery : null,
            };
            if(!valid){
                this.pagination.totalRows = 0;
                this.acertos = [];
                this.isEmpty = true;
                this.isLoading = false;
            }else{
                this.service
                    .findAll(
                        filtro,
                        this.sort,
                        this.order,
                        currentPage - 1,
                        this.pagination.perPage,
                        this.query
                    )
                    .then(r => {
                        this.pagination.totalRows = r.totalElements;
                        this.acertos = r.content;
                        this.isEmpty = this.acertos.length <= 0;
                    })
                    .catch(e => {
                        this.isEmpty = true;
                        this.$root.showMessage("error", "msg-erro-load");
                        console.error("Erro ao carregar.", e);
                    })
                    .finally(_ => {
                        this.pagination.resetPagination = false;
                        this.isLoading = false;
                        this.getTotalValue();
                        this.showTable = true;
                    });
            }
        },
        //DELETAR
        promptForDelete(row) {
            this.delete = row;
            this.$root.confirm({
                message: this.$t("msg-confirmacao-desativacao-acerto-u", 
                    { u: row.usuario.nome }
                ),
                onConfirm: this.deletarAcerto,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        deletarAcerto() {
            this.isLoading = true;
            this.service
                .deleteAcertoById(this.delete.id)
                .then((_) => {
                    this.$root.showMessage("success", "msg-success-del-acerto");
                    this.carregarDados(this.pagination.currentPage);
                })
                .catch((e) => {
                    console.error("Erro ao remover acerto.", e);
                    this.$root.showMessage("error", "msg-problema-realizar-acao");
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        isStatusButtonType(status) {
            if (status == "ABERTO") return "is-danger";
            else if (status == "FECHADO") return "is-success";
            else if (status == "EXCLUIDO") return "is-warning";
            //is-warning | is-danger | is-success
        },
        parseValueSearch(text) {
            //Função para deixar o valor no formato correto para api
            text = text.replace(/[\,]+/g, ".");
            return text;
        },
        onSearch(text) {
            //faz replace da virgula pois a busca no banco precisa ser ocm ponto
            text = this.parseValueSearch(text);
            this.query = text;
            this.carregarDados();
        },
        sortTable(field, order) {
            this.sort = field;
            this.order = order;
            this.carregarDados();
        },
        updateSituacao(t) {
            if (t) {
                this.situacao = this.situacoes[t.id]
                this.situacaoLabel = this.situacoes[t.id]
            } else {
                this.situacao = this.situacoes[3]
                this.situacaoLabel = this.situacoes[3]
            }

            if (this.situacao.paramQuery.toLocaleUpperCase() == "ABERTO") {
                this.isFocusable = false
                this.datainicial = null
                this.datafinal = null
            } else {
                this.isFocusable = true
                if(this.datainicial==null) this.datainicial = this.$moment().subtract(1, 'M').toDate()
                if(this.datafinal==null) this.datafinal = this.$moment().toDate()
            }
            this.carregarDados()
        },
        getTotalValue() {
            this.valorTotalAcertos = 0;
            this.acertos.forEach((acerto) => {
                this.valorTotalAcertos += acerto.valortotal;
            });
        },
        parseDate(date) {
            return this.$moment(date, "DD-MM-YYYY").toDate();
        },
        showMessage(type, message) {
            this.msgs.push(new Message(type, message, true));
        },
        promptOk(message){
            this.$root.alert({
                message: this.$t(message),
                onConfirm: this.carregarDados
            });
        },
        promptMessageCritica(message) {
            this.$root.alert({
                message: this.$t(message),
                onConfirm: () => { 
                    this.$router.push({
                        name: 'des-critica-despesa'
                    });
                }
            });
        },
        promptAlert(message) {
            this.$root.alert({
                message: this.$t(message),
                onConfirm: this.updatePageInterval
            });
        },
        promptConfirm(message, usr){
            this.usuarioGerarDespesa = usr.usuario;
            this.$root.confirm({
                message: this.$t(message),
                onConfirm: this.geraDespesaAutomatica,
                onCancel: this.removeConfirm,
            });
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px 20px 20px;
    min-height: 100%;
    height: 100%;

    .page {
        position: relative;
        border-radius: 2px;
        margin-bottom: 20px;
        height: inherit;
        min-height: 100%;
        
        .pointer {
            cursor: pointer;
        }

        .tooltip {
            display: inline-flex;
        }

        .nav.nav-tabs {
            margin-bottom: 0;
            margin-left: -20px;
            padding-left: 20px;
        }
        .table-tag-full-width {
            width: 100%;
        }
    }

    .color {
        color: $primary-color;
    }
    .situacao-select div {
        height: 40px;
    }
    .calendar-btn {
        padding: 0;
        width: 100px;
        height: 35px;
    }
}

.margin-none {
    margin: 0 !important;
}

.mt-3 {
    margin-top: 5rem !important;
}

.lps-table {
    padding-top: 0px;
    font-size: 14px;
}
</style>